import type React from "react";

import {
  ContextMenu as DesignSystemContextMenu,
  type ContextMenuItem as DesignSystemContextMenuItem,
  type ContextMenuProps,
} from "@/design-system/ContextMenu";
import { useTranslation } from "@/translations";

export type ContextMenuItem = DesignSystemContextMenuItem;

export function ContextMenu({
  items,
  triggerComponent,
  placement = "bottom",
  onOpenComplete,
}: Omit<ContextMenuProps, "triggerLabel">): React.ReactNode {
  const { t } = useTranslation();

  return (
    <DesignSystemContextMenu
      items={items}
      triggerComponent={triggerComponent}
      triggerLabel={t("component.context-menu.action.open")}
      placement={placement}
      onOpenComplete={onOpenComplete}
    />
  );
}
